import { ActionTypes } from '../types/action-types';

export const expandConfigView = (isExpanded: boolean) => ({
    type: ActionTypes.HB_UI_INTEGRATE_UPDATED,
    configuredExpanded: isExpanded,
});
export const expandBYODView = (isExpanded: boolean) => ({
    type: ActionTypes.HB_UI_BYOD_UPDATED,
    byodExpanded: isExpanded
});




// WEBPACK FOOTER //
// ./src/sub-projects/sensibill/actions/app.ts